import { ArrowRight, Bot, CheckCircle2, Gauge, LockKeyhole, Network, ShieldCheck, Sparkles, Workflow } from 'lucide-react';

const pillars = [
  {
    icon: <Bot aria-hidden="true" />,
    title: 'InfraOps AI-first',
    text: 'Agentes especializados para triagem, execução assistida, validação e governança operacional.',
  },
  {
    icon: <Workflow aria-hidden="true" />,
    title: 'Processo que vira execução',
    text: 'Da intenção ao plano, do plano à fila de trabalho, da fila ao deploy auditável.',
  },
  {
    icon: <ShieldCheck aria-hidden="true" />,
    title: 'Enterprise por desenho',
    text: 'Tenant, contrato, SLA, trilha de auditoria, papéis e controles prontos para MSPs.',
  },
  {
    icon: <Network aria-hidden="true" />,
    title: 'Operação conectada',
    text: 'Atendimento, inventário, automações, runbooks e observabilidade em um fluxo único.',
  },
];

const modules = ['Mission Control', 'Zoe Tower', 'Orin Triage', 'Project Ops', 'RAG Operacional', 'Automação & Gates'];

export function App() {
  return (
    <main>
      <section className="hero" aria-labelledby="hero-title">
        <nav className="nav" aria-label="Principal">
          <a className="brand" href="#top" aria-label="InfraFlow Home">
            <span className="brand-mark">IF</span>
            <span><strong>InfraFlow</strong><small>by Infra Network</small></span>
          </a>
          <div className="nav-links">
            <a href="#produto">Produto</a>
            <a href="#plataforma">Plataforma</a>
            <a href="#enterprise">Enterprise</a>
          </div>
        </nav>

        <div className="hero-grid" id="top">
          <div className="hero-copy">
            <span className="eyebrow"><Sparkles size={16} /> InfraOps AI Enterprise</span>
            <h1 id="hero-title">InfraFlow organiza a operação antes que o caos vire custo.</h1>
            <p>
              A plataforma da Infra Network para MSPs operarem atendimento, infraestrutura, automação, governança e IA com controle, evidência e velocidade enterprise.
            </p>
            <div className="actions">
              <a className="button primary" href="mailto:lucas@infranetwork.com.br?subject=Quero%20conhecer%20o%20InfraFlow">
                Solicitar apresentação <ArrowRight size={18} />
              </a>
              <a className="button secondary" href="#plataforma">Ver arquitetura</a>
            </div>
          </div>

          <aside className="panel" aria-label="Resumo operacional">
            <div className="panel-header">
              <span>Mission Control</span>
              <strong>Live Ops</strong>
            </div>
            <div className="status-line"><CheckCircle2 size={16} /> operação auditável por tenant, contrato e SLA</div>
            <div className="metric"><Gauge /><div><strong>24/7</strong><span>operação assistida</span></div></div>
            <div className="metric"><LockKeyhole /><div><strong>Governança</strong><span>decisão, ação e evidência</span></div></div>
            <div className="metric"><ShieldCheck /><div><strong>Trust layer</strong><span>segurança, LGPD e gates</span></div></div>
          </aside>
        </div>
      </section>

      <section id="produto" className="section">
        <span className="section-kicker">Produto</span>
        <h2>Um cockpit operacional para crescer sem perder o controle.</h2>
        <div className="cards">
          {pillars.map((pillar) => (
            <article className="card" key={pillar.title}>
              <div className="card-icon">{pillar.icon}</div>
              <h3>{pillar.title}</h3>
              <p>{pillar.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="plataforma" className="section split">
        <div>
          <span className="section-kicker">Plataforma</span>
          <h2>Camadas claras para produto, operação e engenharia evoluírem juntas.</h2>
          <p>
            A identidade visual agora segue a base do produto: azul profundo, azul InfraFlow, verde operacional e roxo de assets. Visual limpo, forte e preparado para evoluir para o site comercial completo.
          </p>
        </div>
        <ul className="module-list" aria-label="Módulos InfraFlow">
          {modules.map((module) => <li key={module}>{module}</li>)}
        </ul>
      </section>

      <section id="enterprise" className="section enterprise">
        <span className="section-kicker">Enterprise</span>
        <h2>Feito para operação real, não para apresentação vazia.</h2>
        <p>
          Container, CI/CD, Nginx, Certbot, healthcheck e deploy automatizado já estão ativos. O site fica simples por enquanto, mas com a cara certa do InfraFlow.
        </p>
      </section>
    </main>
  );
}
